import React from 'react';
import styled from 'styled-components';
import Chart from 'react-apexcharts';
import { cores, coresGrafico } from '../../../../styles/styleUtils';

const PieChartContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
`;

const PieChartBox = styled.div`
  background-color: ${cores.cinzaClaro};
  border: 1px solid #E2E4E8;
  border-radius: 5px;
  padding: 16px;
`;

const PieChartTitle = styled.h4`
  color: ${cores.cinzaMedio};
  font-size: 1rem;
  margin-bottom: 10px;
`;

const PieChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
`;

const PieChartSection = ({ graficosDespesas }) => {
  const custosFixos = graficosDespesas?.custosFixos || [];
  const equipeComercial = graficosDespesas?.equipeComercial || [];

  const gerarDadosGrafico = (dados) => {
    const total = dados.reduce((acc, item) => acc + item.total, 0);
    const series = dados.map((item) => parseFloat(item.total.toFixed(2)));
    const labels = dados.map((item) => item.nome);
    return { series, labels, total };
  };

  const dadosFixos = gerarDadosGrafico(custosFixos);
  const dadosComercial = gerarDadosGrafico(equipeComercial);

  const opcoesBase = (labels) => ({
    chart: {
      type: 'pie',
    },
    labels,
    legend: {
      position: 'bottom',
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`,
      },
    },
  });

  return (
    <PieChartContainer>
      <PieChartBox>
        <PieChartTitle>Custos Fixos</PieChartTitle>
        <PieChartWrapper>
          <Chart options={opcoesBase(dadosFixos.labels)} series={dadosFixos.series} type="pie" width="150%" />
        </PieChartWrapper>
      </PieChartBox>
      <PieChartBox>
        <PieChartTitle>Equipe Comercial</PieChartTitle>
        <PieChartWrapper>
          <Chart options={opcoesBase(dadosComercial.labels)} series={dadosComercial.series} type="pie" width="150%" />
        </PieChartWrapper>
      </PieChartBox>
    </PieChartContainer>
  );
};

export default PieChartSection;